import { Entity, Field } from 'typegraph';

@Entity({one: "metabaseEmbed", many: ""})
export default class MetabaseEmbed {

	@Field()
	public url: string;

}



// WEBPACK FOOTER //
// ./src/panels/metabase/entities/MetabaseEmbed.ts